// extracted by mini-css-extract-plugin
export var header = "_fk-0";